import React, {useEffect, useState, useRef, useMemo} from 'react';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import performanceService from '../../../services/data/performance.service';
import * as Yup from 'yup';
import companyService from '../../../services/data/company.service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Dropdown } from 'primereact/dropdown';
import { useNavigate } from 'react-router-dom';
import { AutoComplete } from "primereact/autocomplete";
import employeeService from '../../../services/data/employee.service';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import TypeSteps from '../typeSteps';


export default function FormCreatePerformanceReviewAll() {
    
    const toast = useRef(null);

    // autocomplete
    const [search , setSearch] = useState('')
    const [items, setItems] = useState([])
    const [groupedItems, setGroupedItems] = useState([]) // para poder setar ao selecionar
    const [manager, setManager] = useState('')

    const [title, setTitle] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [status, setStatus] = useState('AT')
    const [assessmentType, setAssessmentType] = useState('')
    const assessList = [
        { name: 'Plano de Desenvolvimento', code: 'PD' },
        { name: 'Avaliação 90º', code: 'BD' },
        { name: 'Avaliação 180º', code: 'AD' },
        { name: 'Avaliação 270º', code: 'SD' },
        { name: 'Reunião 1:1', code: 'RD' }
    ];
    
    const [employeeList, setEmployeeList] = useState() //lista para escolher
    const [employees, setEmployees] = useState('') // para ter o ID e buscar no emplist para ter tbm competencias
    const [employeesFinal, setEmployeesFinal] = useState([]) // para enviar pra API

    const [step, setStep] = useState(0)
    const navigate = useNavigate();

    const [loadingList, setLoadingList] = useState(false);
    const [loading, setLoading] = useState(false);

    const load = () => {
        setLoading(true);
        formik.submitForm()
    };

    //auto complete gestor
    const searchItems = (event) => {
        if (event.query.length > 2) {

            setLoadingList(true)
            
            employeeService.autoCompleteEmployeeManager(event.query).then((response) => {
                let resultTitle = response.map((item) => item.user)
                setItems([...resultTitle])
                setGroupedItems(response.map((item) => item))

            })
            .catch((error) => {
                console.log(error.response.data)
            });
        }
    }

    function filterItems() {
        let filtered = groupedItems.find(x => x.user === search)
        setManager(filtered)
        setLoadingList(false)
    }

    function cleanSearch() {
        setSearch('')
        setManager('')
    }


    function listEmployees() {
        
        companyService.getUserTeamJobPosition(manager.id).then((response) => {    
            setEmployeeList(response.results.map((item) => {
                return {
                    name: `${item.user.first_name} ${item.user.last_name}`,
                    value: item.id,
                    internaljobtitle: item.jobposition.internaljobtitle.id,
                    competencies: item.jobposition.internaljobtitle.competencies.map((item) => item.id)
                }
            }))
        }).catch((error) => {
            console.log(error.response)
        });

    }

    useMemo(() => {
        if (employees) {

            let emp = employeeList.filter( (item) => {
                for (let i = 0; i < employees.length; i++) {
                    if (item.value === employees[i]) {
                        return item
                    }
                }
            })

            setEmployeesFinal(emp)
        }        
    }, [employees])

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: title,
            start_date: startDate,
            end_date: endDate,
            status: status,
            assessment_type: assessmentType,
            result_to_matrix: true
        },
        validationSchema: Yup.object({
            start_date: Yup.date(),
            end_date: Yup.date().min(Yup.ref("start_date"), "Data de término tem de ser maior que a data de início"),
        }),
        onSubmit: values => {

            let data = {
                manager_id: manager.id,
                company_id: localStorage.getItem("companyId"),
                title: values.title,
                start_date: values.start_date,
                end_date: values.end_date,
                status: values.status,
                assessment_type: values.assessment_type.code,
                employee: employeesFinal,
                result_to_matrix: values.result_to_matrix
            }

            performanceService.createPerformanceReview(data).then((response) => {
    
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: `${response.title} criado com sucesso`, life: 5000 });
                
                setTimeout(() => {
                    setLoading(false);
                    return navigate(`/performance-review/${response.id}/process/`)
                }, 3000);

                

                
            }).catch((error) => {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data.detail, life: 4000 });
                setLoading(false);
            });

            
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>

            <Toast ref={toast} position="top-right" />

            {
                step == 0 ?
                // setar template
                <>
                <div className="col mb-3">
                    <label className="form-label fw-bold">Escolher Template <span className="text-danger">*</span></label>
                    <div className='p-inputgroup'>
                        <Dropdown placeholder="Selecionar" value={assessmentType} optionLabel="name" options={assessList} onChange={(e) => {setAssessmentType(e.value)} } className="rounded" />
                    </div>
                    <div className='mt-3'>
                        <TypeSteps type={assessmentType.code} />
                    </div>
                </div>
                {
                    assessmentType && step === 0?
                    <>
                    <span className='btn btn-success btn-sm btn-rounded px-4' onClick={() => {setStep(1)}}>
                        Avançar
                    </span>
                    </>
                    : null
                }
                </>
                : null
            }
            {
                step == 1 ?
                // escolher manager
                <>
                    <span role="button" className="nav-link mt-2 mb-3" onClick={() => setStep(0)}>
                        <span className="text-green fw-bold"><FontAwesomeIcon icon={solid('chevron-left')} /> Voltar</span>
                    </span>
                    <p>Template: <span className='fw-bold'>{assessmentType.name}</span></p>
                    <div className="col mb-3">
                        <label className="form-label fw-bold mb-1">Selecionar Gestor <span className="text-danger">*</span></label>
                        <div className='row'>
                            <div className='col-md-9 px-0'>
                                <div className='p-inputgroup'>
                                    <AutoComplete inputClassName='input-search-radius' placeholder='Buscar Gestor pelo Nome' value={search} suggestions={items} completeMethod={searchItems} onChange={(e) => {setSearch(e.value)}} />
                                    <span role='button' className='btn btn-success button-search-radius' onClick={filterItems}>
                                        <FontAwesomeIcon icon={solid('plus-circle')} />
                                    </span>
                                </div>
                            </div>
                            <div className='col'>
                            {
                                loadingList ?
                                <>
                                <ProgressSpinner style={{width: '30px', height: '30px'}} />
                                </>
                                :
                                null
                            }
                            {
                                manager ?
                                <button className='mt-1 btn btn-sm btn-link fw-bold font1em text-grey text-decoration-none' onClick={(e) => cleanSearch()}>
                                    Limpar
                                </button>
                                : null
                            }
                            </div>
                        </div>
                    </div>
                    {
                        manager ?
                        <>
                        <p>Gestor: <span className='fw-bold'>{manager.user}</span></p>
                        <span className='btn btn-success btn-sm btn-rounded px-4' onClick={() => {listEmployees(); setStep(2)}}>
                            Avançar
                        </span>
                        </>
                        : null
                    }
                </>
                :
                null
            }
            
            {
                step == 2 ?
                <>
                {
                    employeeList && employeeList.length > 0 ?
                    <>
                    <span role="button" className="nav-link mt-2 mb-3" onClick={() => setStep(1)}>
                        <span className="text-green fw-bold"><FontAwesomeIcon icon={solid('chevron-left')} /> Voltar</span>
                    </span>
                    <p className='mb-0'>Template: <span className='fw-bold'>{assessmentType.name}</span></p>
                    <p>Gestor: <span className='fw-bold'>{manager.user}</span></p>
                    <div className="col mb-3">
                        <label className="form-label fw-bold mb-0">Enviar para <span className="text-danger">*</span></label>
                        <p className='mb-1'>Selecionar pessoa da equipe</p>
                        <div className='p-inputgroup'>
                            <MultiSelect filter optionLabel="name" placeholder="Selecionar" value={employees} onChange={(e) => setEmployees(e.value)} options={employeeList} display="chip" className="rounded" />
                        </div>
                    </div>
                    </>
                    :
                    <p>Carregando equipe</p>
                }
                {
                    employees ?
                    <>
                    {
                        employees.length > 1 ?
                        <p>Enviando para <span className='fw-bold'>{employees.length}</span> pessoas</p>
                        : null
                    }
                    <span className='btn btn-success btn-sm btn-rounded px-4' onClick={() => {setStep(3)}}>
                        Avançar
                    </span>
                    </>
                    : null
                }
                </>
                :
                null
            }
            {
                step == 3 ?
                <>
                <span role="button" className="nav-link mt-2 mb-3" onClick={() => setStep(2)}>
                    <span className="text-green fw-bold"><FontAwesomeIcon icon={solid('chevron-left')} /> Voltar</span>
                </span>
                <p className='mb-0'>Template: <span className='fw-bold'>{assessmentType.name}</span></p>
                <p className='mb-0'>Gestor: <span className='fw-bold'>{manager.user}</span></p>
                <p>Enviando para <span className='fw-bold'>{employees.length}</span> pessoas</p>
                <div className="col mb-3">
                    <label className="form-label fw-bold">Título <span className="text-danger">*</span></label>
                    <input name='title' type="text" className="form-control text-capitalize" placeholder='Avaliação de Desempenho Semetral' required {...formik.getFieldProps('title')} />
                </div>

                <div className='row mb-4 px-0'>
                    <div className='col'>
                        <label className="form-label fw-bold">Data de Início <span className="text-danger">*</span></label>
                        <input className="form-control" name='start_date' type="date" required="required" autoComplete="off" {...formik.getFieldProps('start_date')} />
                        {formik.errors.start_date ? (<span name="start_date" className="text-vermelho">{formik.errors.start_date}</span>) : null}
                    </div>

                    <div className='col'>
                        <label className="form-label fw-bold">Data de Término <span className="text-danger">*</span></label>
                        <input className="form-control" name='end_date' type="date" required="required" autoComplete="off" {...formik.getFieldProps('end_date')} />
                        {formik.errors.end_date ? (<span name="end_date" className="text-vermelho">{formik.errors.end_date}</span>) : null}
                    </div>
                </div>

                <div className="form-check form-switch mb-4">
                    <label className="form-switch-label">Considerar Resultado na Matriz 9Box?</label>
                    <input className="form-check-input" type="checkbox" role="switch" name='result_to_matrix' aria-checked={formik.values.result_to_matrix} checked={formik.values.result_to_matrix} {...formik.getFieldProps('result_to_matrix')} />
                </div>

                <div className="d-grid mx-auto btnMargin">
                    <Button rounded label="Criar" type='submit' icon="pi pi-check" loading={loading} onClick={load} />
                </div>
                </>
                : null
            }
        </form>
    )
}